import { PRIVE, PUBLIC } from '@/configuration/gabed/emplacement/emplacementAdresseConf';
import store from '@/store/store';
import { ADRESSE } from '@/configuration/gabed/emplacement/emplacementConf';
import booleanConverter from '@/services/import/General/booleanConverter';

export default function fillEmplacementWithData(emplacementReference, emplacement) {
  // dans le cas actuel le code emplacement dans le fichier
  // était juste une liaison avec les baux & bailleurs

  // emplacement.code = '';

  // sinon c'est le cas suivant
  emplacement.code = emplacementReference.codeEmplacement ?? '';

  emplacement.libelle = emplacementReference.libelleEmplacement ?? '';
  emplacement.adresseCadastrale.adresse1 = emplacementReference.adresse1Emplacement ?? '';
  emplacement.adresseCadastrale.adresse2 = emplacementReference.adresse2Emplacement ?? '';
  emplacement.adresseCadastrale.adresse3 = emplacementReference.adresse3Emplacement ?? '';
  emplacement.adresseCadastrale.codePostal = emplacementReference.codePostalEmplacement ?? '';
  emplacement.adresseCadastrale.ville = emplacementReference.villeEmplacement ?? '';
  emplacement.adresseCadastrale.pays = emplacementReference.paysEmplacement ?? '';
  emplacement.adresseCadastrale.codeInsee = emplacementReference.codeInseeEmplacement ?? '';
  emplacement.adresseCadastrale.latitude = emplacementReference.latitudeEmplacement ?? null;
  emplacement.adresseCadastrale.longitude = emplacementReference.longitudeEmplacement ?? null;
  emplacement.description = emplacementReference.descriptionEmplacement ?? '';
  emplacement.societeId = store.getters['societe/societeActiveId'];

  if (emplacement.type === ADRESSE) {
    emplacement.emplacementAdresse.lineaireFacade = emplacementReference
      .lineaireFacadeMetreEmplacement ?? null;
    emplacement.emplacementAdresse.numeroParcelle = emplacementReference.numeroParcelleCadastral ?? '';
    emplacement.emplacementAdresse.domaine = emplacementReference.domaine === PUBLIC
      ? PUBLIC : PRIVE;
  }

  emplacement.emplacementTechnique.codeBarre = emplacementReference.codeBarreEmplacement ?? '';
  emplacement.emplacementTechnique.degreDeniveleTerrain = emplacementReference
    .degreDeniveleTerrain ?? 0;
  emplacement.emplacementTechnique.accesSiteSurRdv = booleanConverter(
    emplacementReference.accesSiteSurRdv,
  );
  emplacement.emplacementTechnique.natureSol = emplacementReference.natureSolEmplacement ?? '';
  emplacement.emplacementTechnique.acces = emplacementReference.accesEmplacement ?? '';
  emplacement.emplacementTechnique.groupeDhabitation = emplacementReference.groupeDhabitationEmplacement ?? '';
  emplacement.emplacementTechnique.numUG = emplacementReference.numUGEmplacement ?? '';
  emplacement.emplacementTechnique.quartier = emplacementReference.quartierEmplacement ?? '';

  const agences = store.getters['societe/agenceActive'];
  const agence = agences.find((agence) => {
    return agence.libelleAgence === emplacementReference.agence;
  });
  emplacement.agenceId = agence ? agence.agenceId : agences[0].agenceId;
  emplacement.numLigne = emplacementReference.numLigne;

  return emplacement;
}
